import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../Header';
import OverallIndividualScore from "./OverallIndividualScore";
import KeyPerformanceAreas from "./KeyPerformanceAreas";
import PrinciplesAndStandards from "./PrinciplesAndStandards";
import PersonalDevelopmentPlan from "./PersonalDevelopmentPlan";
import {RatingsProvider} from "./RatingsContext";


const PerformanceContractForm = () => {
  const [showRow3, setShowRow3] = useState(false);


  const [kpaSelfSectionA, setKpaSelfSectionA] = useState(3.5);
  const [kpaSelfSectionB, setKpaSelfSectionB] = useState(0);
  const [kpaLineManager, setKpaLineManager] = useState(3.5);
  const [selfKpa1, setSelfKpa1] = useState(3.5);
  const [selfKpa2, setSelfKpa2] = useState(3.5);
  const [selfKpa3, setSelfKpa3] = useState(3.5);
  const [weightSelfKPA1, setWeightSelfKPA1] = useState(40);
  const [weightSelfKPA2, setWeightSelfKPA2] = useState(20);
  const [weightSelfKPA3, setWeightSelfKPA3] = useState(40);

  const [weightSelfKPB1, setWeightSelfKPB1] = useState(50);
  const [weightSelfKPB2, setWeightSelfKPB2] = useState(30);
  const [weightSelfKPB3, setWeightSelfKPB3] = useState(20);
  const [sectionATotWeight, setSectionATotWeight] = useState(40);

  const [selfKpaB1, setSelfKpaB1] = useState(0);
  const [selfKpaB2, setSelfKpaB2] = useState(0);
  const [selfKpaB3, setSelfKpaB3] = useState(0);




  return (
    <>
      <RatingsProvider>
        <Header icon={"fa-solid fa-users fa-xl mx-2"} label={"Current Review Cycle / Performance Contract"} />
        <main id="main" className="main">

          <div className='row'>
            <div className='col-lg-12'>
              <div className='card'>

                <div className='card-body'>
                  <div className='section'>
                    <div className="card pb-5 container">
                      <div className="card-body">
                        <div className="container mt-4">
                          <div className="d-flex align-items-center mb-3  bg-tertiary p-2 text-light rounded">
                            <h4 className="mb-0">Performance Contract</h4>
                          </div>
                          <div className='section-body p-3'>
                            <div className="col-md-4">
                              <form>
                                <div className="mb-3 d-flex align-items-center">
                                  <label htmlFor="cycleReview" className="form-label me-3" style={{width: '200px'}}>Cycle Under Review:</label>
                                  <input
                                      type="text"
                                      className="form-control"
                                      id="cycleReview"
                                      value="2024 Cycle Review"
                                      disabled
                                  />
                                </div>
                                <div className="mb-3 d-flex align-items-center">
                                  <label htmlFor="employeeName" className="form-label me-3" style={{width: '200px'}}>Employee Name:</label>
                                  <input
                                      type="text"
                                      className="form-control"
                                      id="employeeName"
                                      value="Lerato Bopape"
                                      disabled
                                  />
                                </div>
                                <div className="mb-3 d-flex align-items-center">
                                  <label htmlFor="positionTitle" className="form-label me-3" style={{width: '200px'}}>Position Title:</label>
                                  <input
                                      type="text"
                                      className="form-control"
                                      id="positionTitle"
                                      value="Programme Manager: Strategic Projects"
                                      disabled
                                  />
                                </div>
                                <div className="mb-3 d-flex align-items-center">
                                  <label htmlFor="lineManager" className="form-label me-3" style={{width: '200px'}}>Line Manager:</label>
                                  <input
                                      type="text"
                                      className="form-control"
                                      id="lineManager"
                                      value="Joe Slovo"
                                      disabled
                                  />
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className='section mb-4'>

                    <div className="card pb-5 container">
                      <div className="card-body"><OverallIndividualScore /></div>
                    </div>

                    <div className="card pb-5 container">
                      <div className="card-body">
                        <KeyPerformanceAreas
                            phase='capture-progress'
                            myKpas={[
                              {
                                kpa: 'Quality of Deliverables: Assess the quality of project deliverables and whether they meet predefined standards and specifications.',
                                weight: '40',
                                selfRating: null,
                                lineManagerRating: null,
                                kpis: [
                                  {
                                    description: 'Mentorship or Pair Programming Sessions',
                                    resources: 'Technology and Tools, Budget, and Leadership Support.',
                                    annualTarget: 'Aim to conduct a minimum of two mentorship or pair programming sessions per month to facilitate knowledge transfer and skill development within the team.',
                                    measurement: 'Number of mentorship or pair sessions conducted with team members.',
                                    progress: '10',
                                    challenges: '',
                                    correctiveMeasures: '',
                                  },
                                  {
                                    description: 'Code Review Participation',
                                    resources: 'Technology and Tools, Budget, and Leadership Support.',
                                    annualTarget: 'Aim to actively participate in at least 90% of code reviews to provide valuable input and maintain code quality.',
                                    measurement: 'Percentage of code reviews participated in within the team.',
                                    progress: '10',
                                    challenges: '',
                                    correctiveMeasures: '',
                                  },
                                ],
                              },
                              {
                                kpa: 'Quality of Deliverables: Assess the quality of project deliverables and whether they meet predefined standards and specifications.',
                                weight: '20',
                                selfRating: null,
                                lineManagerRating: null,
                                kpis: [
                                  {
                                    description: 'Track the effectiveness of the risk management strategy by monitoring the number and impact of risks identified and mitigated during the project.',
                                    resources: 'Achieve a target of mitigating 90% of identified risks annually.',
                                    annualTarget: 'Achieve a target of mitigating 90% of identified risks annually.',
                                    measurement: 'Technology and Tools, Budget, and Leadership Support',
                                    progress: '',
                                    challenges: '',
                                    correctiveMeasures: '',
                                  },
                                ],
                              },
                              {
                                kpa: 'Risk Mitigation',
                                weight: '40',
                                selfRating: null,
                                lineManagerRating: null,
                                kpis: [
                                  {
                                    description: 'Track the effectiveness of the risk management strategy by monitoring the number and impact of risks identified and mitigated during the project.',
                                    resources: 'Achieve a target of mitigating 90% of identified risks annually.',
                                    annualTarget: 'Achieve a target of mitigating 90% of identified risks annually.',
                                    measurement: 'Technology and Tools, Budget, and Leadership Support',
                                    progress: '',
                                    challenges: '',
                                    correctiveMeasures: '',
                                  },
                                ],
                              },
                            ]}
                        /></div>
                    </div>

                    <div className="card pb-5 container">
                      <div className="card-body"><PrinciplesAndStandards phase='capture-progress'  /></div>
                    </div>

                    <div className="card pb-5 container">
                      <div className="card-body"><PersonalDevelopmentPlan phase="capture-progress" /></div>
                    </div>

                    <div className="card p-3 container">
                      <div className="d-flex justify-content-center align-items-center align-content-center">
                        <div className="d-flex">
                          <input type="radio" name="hello" className="mb-4"/>
                          <div className="ms-2">I have finalised my progress capturing</div>
                        </div>
                        <button className='btn btn-secondary btn-sm py-1 my-1 mt-2  text-nowrap ms-auto me-3'>SAVE</button>
                        <button className='btn btn-tertiary btn-sm py-1 my-1 mt-2  text-nowrap'>SUBMIT</button>

                      </div>
                    </div>
                  </div>
             {/*     <div className='section mb-4'>
                    <div className='section-header bg-tertiary p-2 text-light font-weight-600'>
                      Overall Individual Score for Current Cycyle
                    </div>
                    <div className='section-body border'>
                      <div className='d-flex '>
                        <div className='flex-grow-1 bg-secondary p-2 text-light'>Overall Score</div>
                        <div className='flex-grow-1 d-flex pt-2 p-2'>
                          <span className='mt-1'>self:</span>
                          <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                        </div>


                        <div className='flex-grow-1 d-flex pt-2'>
                          <span className='mt-1'>Line Manager:</span>
                          <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                        </div>

                        <div className='flex-grow-1 d-flex pt-2'>
                          <span className='mt-1'>Final / Moderator:</span>
                          <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />

                        </div>

                        <div className='flex-grow-1 d-flex'>
                          <span className='mt-1'>Moderator Comments:</span>
                          <textarea defaultChecked={0} disabled className='form-control my-2 me-2' rows={1} >

                        </textarea>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div className='section mb-4'>
                    <div className=' ps-2 section-header bg-tertiary p-2 text-light font-weight-600 ps-3'>
                      Section A: Key Performance Areas
                    </div>
                    <div className='section-body border'>

                      <div className='d-flex'>
                        <div className=' bg-secondary text-light py-3' style={{ width: "130px" }}>KPA Score (80%)</div>
                        <div className='flex-grow-1 d-flex pt-2 mx-2'>
                          <span className='mt-1'>Weight Total:</span>
                          <input type='number' disabled className='number-input border rounded ms-2' defaultValue={100} />
                        </div>

                        <div className='d-flex'>
                          <div className='flex-grow-1 d-flex pt-2'>
                            <span className='mt-1'>Self:</span>
                            <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                          </div>

                          <div className='flex-grow-1 d-flex pt-2 ms-5'>
                            <span className='mt-1'>Line Manager:</span>
                            <input type='number' disabled className='number-input border rounded ms-2 me-2' defaultValue={0} />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div className='section '>

                    <div className='section-body'>
                      <table className='table table-bordered'>
                        <tbody>
                        <tr>
                          <td className='bg-tertiary text-light'>KPA</td>
                          <td colSpan={2} className='bg-secondary'>
                            <div className='d-flex flex-column'>
                              <div className='text-light'>

                                Quality of Deliverables: Assess the
                                quality of project deliverables
                                and whether they meet predefined
                                standards and specifications.
                              </div>
                              <div className='text-end font-weight-600'> Cascaded as is from Manager</div>
                            </div>
                          </td>
                          <td className='pt-2 ms-5'>
                            <div className='mt-1'>Weight:</div>
                            <input type='number' disabled className='number-input border rounded ms-2' defaultValue={40} />
                          </td>

                          <td className=''>
                            <div className='d-flex'>

                              <div className=''>
                                <div className='d-flex'>
                                  <div className='d-flex'>
                                    <div className='flex-grow-1 d-flex pt-4 ms-5'>
                                      <span className='mt-1'>self:</span>
                                      <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                                    </div>


                                    <div className='flex-grow-1 d-flex pt-4 ms-5'>
                                      <span className='mt-1'>Line Manager:</span>
                                      <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                                    </div>

                                    <div className='flex-grow-1 d-flex ms-3 pt-3'>
                                      <button className='btn btn-secondary btn-sm py-1 my-1 mt-2  text-nowrap mb-3'>Open KPIs</button>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className='bg-tertiary text-light'>KPA</td>
                          <td colSpan={2} className='bg-secondary'>
                            <div className='d-flex flex-column'>
                              <div className='text-light'>

                                Quality of Deliverables: Assess the
                                quality of project deliverables and
                                whether they meet predefined
                                standards and specifications.
                              </div>
                              <div className='text-end font-weight-600'> Customised KPA</div>
                            </div>
                          </td>
                          <td className='pt-2 ms-5 '>
                            <div className='mt-1'>Weight:</div>
                            <input type='number' disabled className='number-input border rounded ms-2' defaultValue={20} />
                          </td>

                          <td className=''>
                            <div className='d-flex'>

                              <div className=''>
                                <div className='d-flex'>
                                  <div className='d-flex'>
                                    <div className='flex-grow-1 d-flex pt-4 ms-5'>
                                      <span className='mt-1'>self:</span>
                                      <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                                    </div>


                                    <div className='flex-grow-1 d-flex pt-4 ms-5'>
                                      <span className='mt-1'>Line Manager:</span>
                                      <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                                    </div>

                                    <div className='flex-grow-1 d-flex ms-3 pt-3'>
                                      <button className='btn btn-secondary btn-sm py-1 my-1 mt-2  text-nowrap mb-3'>Open KPIs</button>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className='bg-tertiary text-light'>KPA</td>
                          <td colSpan={2} className='bg-secondary'>
                            <div className='d-flex flex-column'>
                              <div className='text-light'>
                                Risk Mitigation
                              </div>
                              <div className='text-end font-weight-600'> Customised KPA</div>
                            </div>
                          </td>
                          <td className='pt-2 ms-5 '>
                            <div className='mt-1'>Weight:</div>
                            <input type='number' disabled className='number-input border rounded ms-2' defaultValue={40} />
                          </td>

                          <td className=''>
                            <div className='d-flex'>

                              <div className=''>
                                <div className='d-flex'>
                                  <div className='d-flex'>
                                    <div className='flex-grow-1 d-flex pt-4 ms-5'>
                                      <span className='mt-1'>self:</span>
                                      <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                                    </div>


                                    <div className='flex-grow-1 d-flex pt-4 ms-5'>
                                      <span className='mt-1'>Line Manager:</span>
                                      <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                                    </div>

                                    <div className='flex-grow-1 d-flex ms-3 pt-3'>
                                      <button
                                          className='btn btn-secondary btn-sm py-1 my-1 mt-2  text-nowrap mb-3'
                                          onClick={()=> {setShowRow3(!showRow3)}}
                                      >{showRow3? 'Hide': 'Show'} KPIs</button>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>

                        {showRow3 && (
                            <>
                              <tr className={`fade-in-element ${showRow3 ? 'fade-in' : ''}`}>
                                <td className='title-col'></td>
                                <td className='bg-tertiary text-light title-col'>PI</td>
                                <td className='bg-secondary'>
                                  <div className='d-flex flex-column '>
                                    <div className='text-light'>
                                      Track the effectiveness of the risk
                                      management strategy by monitoring
                                      the number and impact of risks
                                      identified and mitigated during the
                                      project.
                                    </div>
                                    <div className='text-end font-weight-600 font-style-italic'>Customised KPA</div>
                                  </div>
                                </td>
                                <td colSpan={2} className={`fade-in-element ${showRow3 ? 'fade-in' : ''}`}>
                                  <table className='table '>
                                    <tr>
                                      <td>
                                        <div>
                                          <div className=''>Annual Target:</div>
                                          <textarea disabled className='form-control'>
                                      Achieve a target of mitigating 90% of
                                      identified risks annually.
                                    </textarea>
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          <div className='text-wrap'>Resource Requirements & Enabling Conditions:</div>
                                          <textarea disabled className='form-control'>
                                      Technology and Tools, Budget, and
                                      Leadership Support
                                    </textarea>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan="2">
                                        <div>
                                          <div className='text-wrap'>Progress / Challenges / Corrective Measures:</div>
                                          <textarea className='form-control'></textarea>
                                        </div>
                                      </td>

                                    </tr>


                                  </table>
                                </td>
                              </tr>
                            </>
                        )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className='section mt-4'>
                    <div className='section-header bg-tertiary p-2 text-light font-weight-600'>
                      Section B: Our Principles & Standards
                    </div>
                    <div className='section-body border'>

                      <div className='d-flex'>
                        <div className=' bg-secondary text-light p-2 py-3' style={{ width: "200px" }}>Generic Averages (20%)</div>
                        <div className='flex-grow-1 d-flex pt-2 mx-2'>
                          <span className='mt-1'>Weight Total:</span>
                          <input type='number' disabled className='number-input border rounded ms-2' defaultValue={100} />
                        </div>

                        <div className='d-flex'>
                          <div className='flex-grow-1 d-flex pt-2'>
                            <span className='mt-1'>Self:</span>
                            <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                          </div>



                          <div className='flex-grow-1 d-flex pt-2 ms-5'>
                            <span className='mt-1'>Line Manager:</span>
                            <input type='number' disabled className='number-input border rounded ms-2 me-2' defaultValue={0} />
                          </div>


                        </div>
                      </div>

                    </div>
                  </div>

                  <div className='section mt-4'>

                    <div className='section-body'>
                      <table className='table' >
                        <tr>
                          <th >Generic:</th>
                          <th>Guidelines:</th>
                          <th>Weight:</th>
                          <th></th>

                        </tr>
                        <tr>
                          <td>
                            <div>
                            <textarea disabled className='form-control'>
                              Integrity
                            </textarea>
                            </div>
                          </td>
                          <td>
                            <div>
                            <textarea disabled className='form-control'>
                              Always be truthful and honest in actions,
                              communications, and dealings.
                            </textarea>
                            </div>
                          </td>
                          <td>
                            <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                          </td>
                          <td>
                            <div className='d-flex'>
                              <div className='flex-grow-1 d-flex pt-2'>
                                <span className='mt-1'>Self:</span>
                                <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                              </div>
                              <div className='flex-grow-1 d-flex pt-2 ms-5'>
                                <span className='mt-1'>Line Manager:</span>
                                <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                              </div>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <div>
                            <textarea disabled className='form-control'>
                              Culture
                            </textarea>
                            </div>
                          </td>
                          <td>
                            <div>
                            <textarea disabled className='form-control'>
                              Collaboration among teams to leverage
                              collective expertise and perspectives.
                            </textarea>
                            </div>
                          </td>
                          <td>
                            <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                          </td>
                          <td>
                            <div className='d-flex'>
                              <div className='flex-grow-1 d-flex pt-2'>
                                <span className='mt-1'>Self:</span>
                                <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                              </div>
                              <div className='flex-grow-1 d-flex pt-2 ms-5'>
                                <span className='mt-1'>Line Manager:</span>
                                <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                              </div>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <div>
                            <textarea disabled className='form-control'>
                              Problem Solving
                            </textarea>
                            </div>
                          </td>
                          <td>
                            <div>
                            <textarea disabled className='form-control'>
                              Identifying and addressing the root causes
                              of problems rather than addressing symptoms
                            </textarea>
                            </div>
                          </td>
                          <td>
                            <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                          </td>
                          <td>
                            <div className='d-flex'>
                              <div className='flex-grow-1 d-flex pt-2'>
                                <span className='mt-1'>Self:</span>
                                <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                              </div>
                              <div className='flex-grow-1 d-flex pt-2 ms-5'>
                                <span className='mt-1'>Line Manager:</span>
                                <input type='number' disabled className='number-input border rounded ms-2' defaultValue={0} />
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div className='section mt-4'>
                    <div className='section-header bg-tertiary p-2 text-light font-weight-600'>
                      Section C: Personal Development Plan
                    </div>
                    <div className='section-body'>
                      <table className='table ' >
                        <tr>
                          <th >Competency to Address:</th>
                          <th>Proposed Actions:</th>
                          <th>Responsibility:</th>
                          <th>Progress / Outcome:</th>
                        </tr>
                        <tr>
                          <td>
                            <div>
                            <textarea disabled className='form-control'>
                              Financial Management
                            </textarea>
                            </div>
                          </td>
                          <td> <div>
                          <textarea disabled className='form-control'>
                          Find applicable course on Internal LMS system
                          </textarea>
                          </div></td>
                          <td> <div>
                          <textarea disabled className='form-control'>
                          Finish and pass the course. Apply knowledge accordingly.
                          </textarea>
                          </div>
                          </td>
                          <td>
                            <div>
                            <textarea className='form-control'>
                            </textarea>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                            <textarea disabled className='form-control'>
                              Proposal Writing
                            </textarea>
                            </div>
                          </td>
                          <td>
                            <div>
                            <textarea disabled className='form-control'>
                            Find applicable course on Internal LMS system
                            </textarea>
                            </div>
                          </td>
                          <td>
                            <div>
                            <textarea disabled className='form-control'>
                            Finish and pass the course. Improvement in proposal writing.
                            </textarea>
                            </div>
                          </td>
                          <td>
                            <div>
                            <textarea className='form-control'>
                            </textarea>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>*/}

                </div>
              </div>
            </div>
          </div>
        </main >
      </RatingsProvider>
    </>
  )
}
export default PerformanceContractForm;
